import { useEffect } from 'react';
import Footer from '../home/components/Footer';

export default function TermsOfService() {
  // Scroll to top when the component mounts
  useEffect(() => {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.error('Failed to scroll to top:', error);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-[#e8e6e3] sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="cursor-pointer">
            <img
              src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/d0e0e0e0e0e0e0e0e0e0e0e0e0e0e0e0.png"
              alt="MeVER Chair ロゴ"
              title="MeVER Chair"
              className="h-8 w-auto"
            />
          </a>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-[#1a1a2e] mb-8">利用規約</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-base text-[#4a4a4a] leading-relaxed mb-8">
            この利用規約(以下、「本規約」といいます。)は、ビットムーブスジャパン株式会社(以下、「当社」といいます。)がこのウェブサイト上で提供するサイト「MeVER」(以下、「本サービス」といいます。)の利用条件を定めるものです。法人のお客様(以下、「法人ユーザー」といいます。)及び個人のお客様(以下、「個人ユーザー」といい、法人ユーザーと併せて「ユーザー」といいます。)には、本規約に従って、本サービスをご利用いただきます。
          </p>
          <p className="text-base text-[#4a4a4a] leading-relaxed mb-8">
            当サイトをご利用される前によくお読みいただき、ご同意の上ご利用頂くようお願い申し上げます。当サイトをご利用頂いた場合には、本規約すべてにご同意頂いたものとして取り扱わせていただきますので、あらかじめご了承ください。
          </p>

          {/* 第1条 */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-[#1a1a2e] mb-4">第1条（適用）</h2>
            <ol className="list-decimal list-inside space-y-3 text-base text-[#4a4a4a] leading-relaxed pl-4">
              <li>本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。</li>
              <li>当社は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め(以下、「個別規定」といいます。)をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。</li>
              <li>本規約の定めが前項の個別規定の定めと矛盾する場合には、個別規定において特段の定めなき限り、個別規定の定めが優先されるものとします。</li>
              <li>法人ユーザーとの取引については、別途締結する個別契約書の定めが本規約に優先するものとします。</li>
            </ol>
          </section>

          {/* 第2条 */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-[#1a1a2e] mb-4">第2条（提供されるサービス）</h2>
            <p className="text-base text-[#4a4a4a] leading-relaxed mb-4">
              当社が提供するサービスは、次の各号に掲げるサービス(以下「本サービス」といいます)とします。
            </p>
            <ul className="list-disc list-inside space-y-2 text-base text-[#4a4a4a] leading-relaxed pl-4 mb-4">
              <li>物品販売サービス（法人向け一括購入を含む）</li>
              <li>情報提供サービス</li>
              <li>法人向けカスタマイズ・導入支援サービス</li>
              <li>アフターサポート・メンテナンスサービス</li>
              <li>上記各号に付随する各種サービス</li>
              <li>今後当社が提供する各種サービス</li>
            </ul>
            <p className="text-base text-[#4a4a4a] leading-relaxed">
              当社は、本サービスの内容を任意に改定できるものとします。
            </p>
          </section>

          {/* 第3条 */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-[#1a1a2e] mb-4">第3条（利用登録）</h2>
            <ol className="list-decimal list-inside space-y-3 text-base text-[#4a4a4a] leading-relaxed pl-4">
              <li>本サービスにおいては、登録希望者が本規約に同意の上、当社の定める方法によって利用登録を申請し、当社がこれに対する承認を登録希望者に通知することによって、利用登録が完了するものとします。</li>
              <li>法人ユーザーの場合、登録申請者は当該法人を代表して契約を締結する権限を有することを保証するものとします。</li>
              <li>
                当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
                <ul className="list-disc list-inside space-y-2 mt-2 ml-6">
                  <li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
                  <li>本規約に違反したことがある者からの申請である場合</li>
                  <li>法人ユーザーが反社会的勢力に該当する、または関係があると認められる場合</li>
                  <li>その他、当社が利用登録を相当でないと判断した場合</li>
                </ul>
              </li>
            </ol>
          </section>

          {/* 第4条 */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-[#1a1a2e] mb-4">第4条（ユーザーIDおよびパスワードの管理）</h2>
            <ol className="list-decimal list-inside space-y-3 text-base text-[#4a4a4a] leading-relaxed pl-4">
              <li>ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを管理するものとします。</li>
              <li>ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。当社は、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。</li>
              <li>法人ユーザーは、自社の従業員等に対してユーザーIDおよびパスワードを付与する場合、当該従業員等による本規約の遵守について責任を負うものとします。</li>
              <li>ユーザーID及びパスワードが第三者に使用されたことによって生じた損害は、当社に故意又は重大な過失がある場合を除き、当社は一切の責任を負わないものとします。</li>
              <li>ユーザーは、ユーザーID及びパスワードが第三者によって不正に使用されていることが判明した場合には、直ちに当社に通知するとともに、当社からの指示がある場合にはこれに従うものとします。</li>
            </ol>
          </section>

          {/* 第5条 */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-[#1a1a2e] mb-4">第5条（退会）</h2>
            <p className="text-base text-[#4a4a4a] leading-relaxed">
              ユーザーは、所定の退会手続きにより、本サービスから退会できるものとします。ただし、法人ユーザーが継続的な取引契約を締結している場合は、当該契約の定めに従うものとします。
            </p>
          </section>

          {/* ... (the remaining sections are unchanged) ... */}

          {/* 第24条 */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-[#1a1a2e] mb-4">第24条（準拠法・裁判管轄）</h2>
            <ol className="list-decimal list-inside space-y-3 text-base text-[#4a4a4a] leading-relaxed pl-4">
              <li>本規約の解釈にあたっては、日本法を準拠法とします。なお、本サービスに関しては、国際物品売買契約に関する国際連合条約の適用を排除します。</li>
              <li>本サービスの利用に関し、規約により解決できない問題が生じた場合は、ユーザーと当社は誠意をもって協議し、解決を図ります。</li>
              <li>本サービスに関する紛争が生じた場合、東京地方裁判所及び東京簡易裁判所を専属的合意管轄裁判所とします。</li>
            </ol>
          </section>

          {/* 制定日 */}
          <div className="mt-12 pt-8 border-t border-[#e8e6e3]">
            <p className="text-base text-[#4a4a4a]">2025年4月30日制定</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
